/* PN - Kademeli sepet indirimi karti.
   Butun metinler tema ayarlarindan gelir; bu dosyada sabit yazi YOKTUR.
   Yer tutucular: {adet} {oran} {kalan}  ({kazanc} 25.09.2026'dan beri kullanilmiyor)
   Ikame edilen deger otomatik kalin basilir; onundeki % isareti de kalina dahil olur.

   SEPET SAYIMI cart.item_count DEGILDIR.
   hediye-urunu / firsat-kutusu etiketli satirlar esige sayilmaz - Shopify'daki
   otomatik indirim de onlari saymiyor.

   TAZELEME IKI ASAMALI:
   1) /cart.js - kucuk ve hizli, hediye satirlarini (_Gifted benzeri ozellik)
      ayiklar. Musteri degisimi hemen gorur.
   2) ?sections=<id> ile kart bolumu yeniden bastirilir - etiket mantigi
      Liquid'de oldugu icin kesin sonuc budur, birinciyi duzeltir.

   DIKKAT 1: bolum istegine Accept: application/json BASLIGI KONULMAZ. Konulursa
   Shopify bolum HTML'i yerine urunun JSON'unu dondurur ve tazeleme sessizce
   basarisiz olur.

   DIKKAT 2: TETIKLEYICI SEPET ISTEGININ KENDISIDIR, sepet rozeti DEGIL.
   Once mini-cart / cart-icon-bubble ogesine MutationObserver kurulmustu; tema ve
   uygulamalar sepeti farkli yollardan guncelledigi (ve bazen ogeyi komple
   degistirdigi) icin kart guncellenmiyordu, kullanici sayfayi yenilemek zorunda
   kaliyordu. Artik window.fetch ve XMLHttpRequest sarmalaniyor: /cart/add,
   /cart/change, /cart/update, /cart/clear isteklerinin HEPSI yakalaniyor -
   temanin kendi butonu, firsat kutusu, kargo karti, EasyGift hediyesi, hangisi
   olursa olsun. Rozet gozlemcisi ikinci guvence olarak duruyor.
   /cart.js ve ?sections= istekleri bu kaliba UYMAZ, yani dongu olusmaz.

   URUN SAYFASI DISINDA (ornek: Ayin Firsatlari) data-fiyat bos gelir. O zaman
   eklenecek adet 0 sayilir: kart yalniz sepetin GERCEK durumunu anlatir.

   TUTAR YOK (25.09.2026 - PN 2.89): kart ve Solen basamaklari yalniz ORANI yazar,
   TL tutari (kazanc) hic gostermez. data-kazanc-goster ve data-t-kazanc artik
   okunmuyor; temadaki "TL tutari goster" kutulari bu yuzden etkisiz. */
(function () {
  var KOK = '[data-pn-kd]';
  var TIK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function tamsayi(v, yedek) {
    var n = parseInt(v, 10);
    return isNaN(n) ? yedek : n;
  }

  function kacis(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function doldur(sablon, deger) {
    return kacis(sablon).replace(/%?\{(adet|oran|kalan|kazanc)\}/g, function (tam, ad) {
      if (deger[ad] == null) return '';
      return '<b>' + tam.replace('{' + ad + '}', deger[ad]) + '</b>';
    });
  }

  function kademeler(kok) {
    var a = (kok.dataset.adetler || '').split(',');
    var o = (kok.dataset.oranlar || '').split(',');
    var liste = [];
    for (var i = 0; i < a.length; i++) {
      var adet = tamsayi(a[i], 0);
      if (adet > 0) liste.push({ adet: adet, oran: tamsayi(o[i], 0) });
    }
    return liste;
  }

  function urunSayfasiMi(kok) { return !!kok.dataset.fiyat; }

  function form(kok) {
    return kok.closest('form') || kok.closest('product-form') || document;
  }

  function secilenAdet(kok) {
    if (!urunSayfasiMi(kok)) return 0;
    var giris = form(kok).querySelector('input[name="quantity"]');
    var n = giris ? tamsayi(giris.value, 1) : 1;
    return n > 0 ? n : 1;
  }

  function birimFiyat(kok) {
    var varsayilan = tamsayi(kok.dataset.fiyat, 0);
    var giris = form(kok).querySelector('input[name="id"], select[name="id"]');
    if (!giris) return varsayilan;
    var harita;
    try { harita = JSON.parse(kok.dataset.fiyatlar || '{}'); } catch (e) { return varsayilan; }
    var f = harita[String(giris.value)];
    return typeof f === 'number' ? f : varsayilan;
  }

  function ciz(kok) {
    var liste = kademeler(kok);
    if (!liste.length) return;

    var sepetAdet = tamsayi(kok.dataset.sepet, 0);
    var sepetTutar = tamsayi(kok.dataset.araToplam, 0);
    var adet = secilenAdet(kok);
    var birim = birimFiyat(kok);

    var aktifOran = 0, siradakiEsik = 0, siradakiOran = 0;
    liste.forEach(function (k) {
      if (sepetAdet >= k.adet) {
        aktifOran = k.oran;
      } else if (siradakiEsik === 0) {
        siradakiEsik = k.adet;
        siradakiOran = k.oran;
      }
    });

    kok.querySelectorAll('.pn-kd__satir').forEach(function (satir) {
      var esik = tamsayi(satir.dataset.esik, 0);
      var ikon = satir.querySelector('[data-pn-kd-ikon]');
      satir.classList.remove('is-kazanildi', 'is-hedef');
      if (sepetAdet >= esik) {
        satir.classList.add('is-kazanildi');
        if (ikon && !ikon.querySelector('svg')) ikon.innerHTML = TIK;
      } else {
        if (esik === siradakiEsik) satir.classList.add('is-hedef');
        if (ikon && ikon.querySelector('svg')) ikon.textContent = ikon.dataset.rakam || String(esik);
      }
    });

    var kalan = siradakiEsik > 0 ? siradakiEsik - sepetAdet : 0;
    var buEkleyinceYeter = adet > 0 && kalan > 0 && kalan <= adet;

    var dolu = kok.querySelector('[data-pn-kd-bar-dolu]');
    var ek = kok.querySelector('[data-pn-kd-bar-ek]');
    if (dolu && ek) {
      if (siradakiEsik > 0) {
        dolu.style.width = (sepetAdet * 100 / siradakiEsik) + '%';
        ek.style.width = (Math.min(adet, kalan) * 100 / siradakiEsik) + '%';
      } else {
        dolu.style.width = '100%';
        ek.style.width = '0%';
      }
    }

    var metin = kok.querySelector('[data-pn-kd-mesaj-metin]');
    if (!metin) return;

    var d = kok.dataset;
    var govde = '', kuyruk = '';

    if (aktifOran > 0) {
      govde = doldur(d.tAktif, { oran: aktifOran });
      if (siradakiEsik > 0) {
        kuyruk = doldur(buEkleyinceYeter ? d.tSonrakiBir : d.tSonraki, { oran: siradakiOran, kalan: kalan, adet: siradakiEsik });
      }
    } else if (buEkleyinceYeter) {
      govde = doldur(d.tAcilir, { oran: siradakiOran, adet: siradakiEsik, kalan: kalan });
    } else if (siradakiEsik > 0) {
      govde = doldur(d.tBaslat, { adet: siradakiEsik, oran: siradakiOran, kalan: kalan });
    } else {
      govde = doldur(d.tEnUst, {});
    }

    metin.innerHTML = kuyruk ? govde + ' — ' + kuyruk : govde;
  }

  function bolumId(kok) {
    var b = kok.closest('[id^="shopify-section-"]');
    return b ? b.id.replace('shopify-section-', '') : null;
  }

  function sunucudanTazele(kok) {
    var id = bolumId(kok);
    if (!id) return Promise.reject();
    var adres = location.pathname + location.search +
      (location.search ? '&' : '?') + 'sections=' + encodeURIComponent(id);
    return fetch(adres)
      .then(function (c) { return c.ok ? c.json() : Promise.reject(); })
      .then(function (veri) {
        var html = veri[id];
        if (!html) return Promise.reject();
        var gecici = document.createElement('div');
        gecici.innerHTML = html;
        var taze = gecici.querySelector(KOK);
        if (!taze || taze.dataset.sepet == null) return Promise.reject();
        kok.dataset.sepet = taze.dataset.sepet;
        kok.dataset.araToplam = taze.dataset.araToplam || '0';
        ciz(kok);
      });
  }

  function sepettenTazele(kok) {
    var yol = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(yol + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (c) { return c.ok ? c.json() : null; })
      .then(function (sepet) {
        if (!sepet || !sepet.items) return;
        var adet = 0, tutar = 0;
        sepet.items.forEach(function (satir) {
          var hediye = false;
          if (satir.properties) {
            for (var anahtar in satir.properties) {
              if (anahtar.charAt(0) === '_' && /gift|hediye/i.test(anahtar)) hediye = true;
            }
          }
          if (hediye) return;
          adet += satir.quantity || 0;
          tutar += (satir.original_line_price != null ? satir.original_line_price : satir.line_price) || 0;
        });
        kok.dataset.sepet = String(adet);
        kok.dataset.araToplam = String(tutar);
        ciz(kok);
      })
      .catch(function () {});
  }

  function tazele(kok) {
    clearTimeout(kok.pnKdZaman);
    kok.pnKdZaman = setTimeout(function () {
      sepettenTazele(kok);                                  // 1. hizli gecis
      sunucudanTazele(kok).catch(function () {});            // 2. kesin gecis
    }, 80);
  }

  /* ---- sepeti degistiren her istegi yakala ------------------------------ */

  function sepetIstegiMi(url) {
    return /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(String(url || ''));
  }

  function kancaKur() {
    if (window.__pnKdKanca) return;
    window.__pnKdKanca = [];

    var calistir = function () {
      window.__pnKdKanca.forEach(function (f) { try { f(); } catch (e) {} });
    };

    if (window.fetch) {
      var asilFetch = window.fetch;
      window.fetch = function (girdi) {
        var adres = girdi && girdi.url ? girdi.url : girdi;
        var sonuc = asilFetch.apply(this, arguments);
        if (sepetIstegiMi(adres) && sonuc && sonuc.then) {
          sonuc.then(calistir, function () {});
        }
        return sonuc;
      };
    }

    if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
      var ac = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (yontem, url) {
        try { this.__pnKdSepet = sepetIstegiMi(url); } catch (e) {}
        return ac.apply(this, arguments);
      };
      var gonder = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        try {
          if (this.__pnKdSepet) this.addEventListener('loadend', calistir);
        } catch (e) {}
        return gonder.apply(this, arguments);
      };
    }
  }

  function bagla(kok) {
    if (kok.pnKdHazir) return;
    kok.pnKdHazir = true;

    kancaKur();
    window.__pnKdKanca.push(function () { tazele(kok); });

    var f = form(kok);
    if (f && f.addEventListener) {
      ['change', 'input'].forEach(function (olay) {
        f.addEventListener(olay, function (e) {
          if (e.target && (e.target.name === 'quantity' || e.target.name === 'id')) ciz(kok);
        });
      });
      f.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.quantity__button')) {
          setTimeout(function () { ciz(kok); }, 0);
        }
      });
    }

    var rozet = document.querySelector('cart-icon-bubble, .cart-count-bubble, mini-cart');
    var izlenen = rozet && rozet.parentElement ? rozet.parentElement : rozet;
    if (izlenen && window.MutationObserver) {
      new MutationObserver(function () { tazele(kok); })
        .observe(izlenen, { childList: true, subtree: true, characterData: true });
    }

    var gizli = f && f.querySelector ? f.querySelector('input[name="id"]') : null;
    if (gizli && window.MutationObserver) {
      new MutationObserver(function () { ciz(kok); })
        .observe(gizli, { attributes: true, attributeFilter: ['value'] });
    }

    ciz(kok);
  }

  function baslat() { document.querySelectorAll(KOK).forEach(bagla); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
  document.addEventListener('shopify:section:load', baslat);
})();